import css from 'styled-jsx/css';

const styles = css`a{color:inherit;text-decoration:none;display:inline-block}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb250ZW50LWNhcmQvbGluay9jb250ZW50LWNhcmQtbGluay5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLEVBQ0UsYUFBQSxDQUNBLG9CQUFBLENBQ0Esb0JBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJhIHtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`;

export default styles;